/* Tessera Diamonds — Default product page: variant picker + gallery.
   Reads pre-formatted variant JSON (money strings from Liquid) so no formatting here. */
(function () {
  var form = document.getElementById('pdp-form');
  var dataEl = document.getElementById('pdpVariants');
  if (!form || !dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = Array.prototype.slice.call(form.querySelectorAll('.pdp-opt__select'));
  var idInput = document.getElementById('pdpVariantId');
  var priceEl = document.getElementById('pdpPrice');
  var addBtn = document.getElementById('pdpAddBtn');
  var mainImg = document.getElementById('pdpMainImg');

  function chosen() { return selects.map(function (s) { return s.value; }); }

  function match(opts) {
    return variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function setPrice(v) {
    if (!priceEl) return;
    if (v.compare) {
      priceEl.innerHTML = v.price + '<span class="pdp-price__cut">' + v.compare + '</span>';
    } else {
      priceEl.textContent = v.price;
    }
  }

  function update() {
    var v = match(chosen());
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    setPrice(v);
    if (v.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
    }
    if (mainImg && v.image) {
      mainImg.src = v.image;
      syncThumb(v.image);
    }
  }

  function syncThumb(src) {
    thumbs.forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-full') === src);
    });
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });

  // Gallery thumbnails
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-full');
      if (mainImg && full) mainImg.src = full;
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });
})();
